module.exports = __webpack_public_path__ + "img/manual-transaction.2dfab430.png";